import moment from "moment-timezone";
import { PillboxCellRenderer } from "tap/components/AGGrid/cell-renderers/PillboxCellRenderer.jsx";
import { CustomHeader } from "tap/components/AGGrid/cell-renderers/CustomHeader.jsx";
import { roleMapping } from "tap/utils/userRoles.js";

export const id = {
  field: "id",
  headerName: "ID",
  width: 100,
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "id",
    page: "users",
  },
};

export const username = {
  field: "username",
  headerName: "Email Address",
  minWidth: 300,
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "username",
    page: "users",
  },
};

export const fullName = {
  field: "fullName",
  headerName: "Name",
  minWidth: 300,
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "fullName",
    page: "users",
  },
};

export const lastLogin = {
  field: "lastLogin",
  headerName: "Last Login",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  width: 200,
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "lastLogin",
    page: "users",
  },
};

export const status = {
  field: "status",
  headerName: "Status",
  minWidth: 150,
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "status",
    page: "users",
  },
};

export const spaUserRoleIds = {
  field: "spaUserRoleIds",
  headerName: "Roles",
  valueFormatter: ({ value }) =>
    Array.isArray(value)
      ? value
          .map((id) => roleMapping.find((r) => r.id === id)?.roleName || id)
          .join(", ")
      : "",
  cellRenderer: PillboxCellRenderer(),
  minWidth: 800,
  autoHeight: true,
  wrapText: true,
};

export const rightslineId = {
  field: "rightslineId",
  headerName: "Rightsline ID",
  minWidth: 100,
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "rightslineId",
    page: "users",
  },
};
